import { AnyAction } from 'redux';

import {
  GetReturnNote, GetCustomersByName,
  UpdateSearchedName, SelectCustomer, SaveReturnNote,
  UpdateValidationObject, ToggleShowCustomerModal, UpdateComment
} from '../actions/actionTypes';
import { updateObject } from '../../services/utilService';
import { ReturnNoteType } from '../../shared/models/returnNoteModels';

const initialState = {
  masterData: [],
  modelOtherId: null,
  equipmentOther1Id: null,
  equipmentOther2Id: null,
  returnNote: {
    id: '',
    productTypeID: '',
    customerId: '',
    currentColPosition: '',
    serialNo: '',
    raisedByUserId: '',
    raisedBy: '',
    raisedByDate: '',
    year: '',
    model: [],
    modelOtherValue: '',
    reason: [],
    faultDescription: '',
    reasonForReturn: '',
    action: [],
    gases: [],
    updated_by: '',
    returnNo: '',
    comments: '',
    selectedEquipments: {},
    equipmentOther1Value: '',
    equipmentOther2Value: '',
    commentsHistories: [],
    voltage: null
  },
  customerList: [],
  searchedName: '',
  selectedCustomer: null,
  validations: {
    serialNo: {
      required: true,
      type: 'text',
      isValid: false,
      maxLength: 9,
      errorMessage: {
        required: '',
        maxLength: '',
        serialNoExist: '',
      }
    },
    selectedCustomer: {
      required: true,
      checkKeyName: 'id',
      isObject: true,
      type: 'select',
      isValid: false,
      errorMessage: {
        required: '',
        select: ''
      }
    },
    model: {
      required: true,
      isArray: true,
      type: 'radio',
      isValid: false,
      errorMessage: {
        required: ''
      }
    },
    modelOtherValue: {
      type: 'text',
      isValid: true,
      errorMessage: {
        required: ''
      }
    },
    action: {
      required: true,
      isArray: true,
      type: 'radio',
      isValid: false,
      errorMessage: {
        required: ''
      }
    },
    gases: {
      required: true,
      isArray: true,
      type: 'radio',
      isValid: false,
      errorMessage: {
        required: ''
      }
    },
    reason: {
      required: true,
      isArray: true,
      type: 'radio',
      isValid: false,
      errorMessage: {
        required: ''
      }
    },
    selectedEquipments: {
      required: false,
      isObject: true,
      type: 'checkbox',
      valueType: 'number',
      isValid: false,
      errorMessage: {
        min: '',
        max: ''
      },
      min: 1,
      max: 12
    },
    equipmentOther1Value: {
      label: 'other1',
      type: 'text',
      isValid: true,
      errorMessage: {
        required: ''
      }
    },
    equipmentOther2Value: {
      label: 'other2',
      type: 'text',
      isValid: true,
      errorMessage: {
        required: ''
      }
    },
    voltage: {
      required: false,
      valueType: 'decimal',
      regex: /^\d+(\.\d{1,2})?$/,
      isValid: false,
      errorMessage: {
        pattern: ''
      }
    }
  },
  isEditMode: false,
  showModal: false,
};

const getReturnNote = (state: any, action: any) => {
  const { payload } = action;
  if (payload) {
    const masterData = payload.masterData;
    const modelOther = masterData.listOfModels.find(model => model.name.toLowerCase() === 'other');
    const equipmentOther1 = masterData.listOfEquipments.find(item => item.name.toLowerCase() === 'other1');
    const equipmentOther2 = masterData.listOfEquipments.find(item => item.name.toLowerCase() === 'other2');

    let modelOtherId = 0;
    let equipmentOther1Id = 0;
    let equipmentOther1Value = '';
    let equipmentOther2Id = 0;
    let equipmentOther2Value = '';
    if (modelOther) {
      modelOtherId = modelOther.id;
    }
    if (equipmentOther1) {
      equipmentOther1Id = equipmentOther1.id;
      equipmentOther1Value = payload.selectedEquipments ? payload.selectedEquipments[equipmentOther1.id] : '';
    }

    if (equipmentOther2) {
      equipmentOther2Id = equipmentOther2.id;
      equipmentOther2Value = payload.selectedEquipments ? payload.selectedEquipments[equipmentOther2.id] : '';
    }
    delete payload.masterData;
    return updateObject(state, Object.assign({}, {
      returnNote: {
        ...state.returnNote,
        ...payload,
        equipmentOther1Value,
        equipmentOther2Value,
        model: payload.model || [],
        gases: payload.gases || [],
        action: payload.action || [],
        reason: payload.reason || [],
        selectedEquipments: payload.selectedEquipments || {}
      },
      modelOtherId,
      equipmentOther1Id,
      equipmentOther2Id,
      masterData,
      isEditMode: payload.id ? true : false,
      validations: {
        ...state.validations,
        gases: {
          ...state.validations.gases,
          required: ReturnNoteType.LeakDetection != payload.productTypeID
        },
        modelOtherValue: {
          ...state.validations.modelOtherValue,
          required: payload.model[0] === modelOtherId
        },
        equipmentOther1Value: {
          ...state.validations.equipmentOther1Value,
          required: payload.model[0] === equipmentOther1Id
        }
      }
    }));
  } else {
    return updateObject(state, { ...initialState });
  }
}

const getCustomersByName = (state: any, action: any) => {
  return updateObject(state, {
    customerList: action.payload
  });
}

const updateSearchedName = (state: any, action: any) => {
  return updateObject(state, {
    searchedName: action.payload
  });
}

const selectCustomer = (state: any, action: any) => {
  return updateObject(state, {
    selectedCustomer: action.payload
  });
}

const saveReturnNote = (state: any, action: any) => {
  return updateObject(state, Object.assign({}, { ...initialState }));
}

const updateValidationObject = (state: any, action: any) => {
  return updateObject(state, { validations: { ...action.payload } });
}

const toggleShowModal = (state: any, action: any) => {
  return updateObject(state, { showModal: action.payload })
}

const updateCommentsHistories = (state: any, payload: any) => {
  return updateObject(state, {
    returnNote: {
      ...state.returnNote,
      commentsHistories: payload
    }
  })
}

const returnNoteReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case GetReturnNote: return getReturnNote(state, action);
    case GetCustomersByName: return getCustomersByName(state, action);
    case UpdateSearchedName: return updateSearchedName(state, action);
    case SelectCustomer: return selectCustomer(state, action);
    case SaveReturnNote: return saveReturnNote(state, action);
    case UpdateValidationObject: return updateValidationObject(state, action);
    case ToggleShowCustomerModal: return toggleShowModal(state, action);
    case UpdateComment: return updateCommentsHistories(state, action.payload);
    default: return state;
  }
}

export default returnNoteReducer;